import React from "react"

interface NeloBackgroundContainerProps {
  children: React.ReactNode
  title?: string
  subtitle?: string
  onSubtitleClick?: () => void
}

const NeloBackgroundContainer: React.FC<NeloBackgroundContainerProps> = ({ children, title, subtitle, onSubtitleClick }) => {
  return (
    <div className="my-6 space-y-4 rounded-lg bg-nelo-light-gray px-6 py-4">
      <div className="flex items-center justify-between">
        {title && <h1 className="font-manrope text-lg font-semibold">{title}</h1>}
        {subtitle && (
          <h2 className="cursor-pointer font-manrope text-sm text-nelo-blue hover:text-nelo-sky" onClick={onSubtitleClick}>
            {subtitle}
          </h2>
        )}
      </div>
      {children}
    </div>
  )
}

export default NeloBackgroundContainer
